import { Grid, InputAdornment } from "@material-ui/core";
import React, { Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { SERVICE_PREFERRED_SEX } from "../../../../../../../../api/service/service.types";
import useFormatters from "../../../../../../../../components/FormattedFields/useFormatters";
import {
  FormikRadioGroup,
  FormikSelect,
  FormikTextField,
} from "../../../../../../../../components/FormikFields";
import FormikDatePicker from "../../../../../../../../components/FormikFields/FormikDatePicker";
import FormikModalCheckboxes from "../../../../../../../../components/FormikFields/FormikModalCheckboxes";
import { tasksList } from "../../../../../../../../util/defaults/tareas";
import FormBox from "../../../FormComponents/FormBox";
import FormBoxTitle from "../../../FormComponents/FormBoxTitle";
import VisibleForClient from "../../VisibleForClient";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import ListAltIcon from "@material-ui/icons/ListAlt";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { Alert } from "@material-ui/lab";
import styled from "styled-components";
import FormSection from "../../../FormComponents/FormSection";

const StyledAlert = styled(Alert)`
  .MuiAlert-message {
    font-size: 0.875rem;
    line-height: 1.35;
  }

  margin-bottom: 0.75rem;
`;

interface ISelectionFormProps {
  salaryTypeOptions: { value: string; label: string }[];
  officialDegreeOptions: { value: string; label: string }[];
  disableContractConditions?: boolean;
}

const SelectionForm = (props: ISelectionFormProps) => {
  const {
    salaryTypeOptions,
    officialDegreeOptions,
    disableContractConditions,
  } = props;
  const { formatMessage } = useIntl();
  const { formatServiceSex } = useFormatters();

  const tasksOptions = tasksList("es").map((task) => ({
    value: task.value,
    label: task.label,
  }));

  return (
    <Fragment>
      <FormBox>
        <FormBoxTitle
          title={formatMessage({
            id: "ServiceValuationForm.TasksTitle",
            defaultMessage: "Tareas solicitadas",
          })}
          icon={<ListAltIcon />}
        />
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <FormikModalCheckboxes
              name="Tareas_solicitadas"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Tasks"
                  defaultMessage="Tareas"
                />
              }
              required
              fullWidth
              options={tasksOptions}
              messages={{
                addLabel: formatMessage({
                  id: "ServiceValuationForm.AddTask",
                  defaultMessage: "Añadir",
                }),
                dialogCancelButton: formatMessage({
                  id: "ServiceValutaionForm.TasksCancel",
                  defaultMessage: "Cancelar",
                }),
                dialogAcceptButton: formatMessage({
                  id: "ServiceValuationForm.TasksAccept",
                  defaultMessage: "Aceptar",
                }),
                dialogTitle: formatMessage({
                  id: "ServiceValuationForm.TasksModify",
                  defaultMessage: "Modificar Tareas",
                }),
              }}
            />
          </Grid>
        </Grid>
      </FormBox>

      <FormSection>
        <Grid container spacing={8}>
          <Grid item xs={12} md={12}>
            <FormikTextField
              name="Rutinas"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Rutinas / Otros requisitos"
                  defaultMessage="Rutinas / Otros requisitos"
                />
              }
              fullWidth
              multiline
              minRows="3"
              maxRows="5"
              margin="nomargin"
            />
          </Grid>
        </Grid>
      </FormSection>

      {/* <FormBox>
        <FormBoxTitle
          title={formatMessage({
            id: "ServiceValuationForm.TasksTitle",
            defaultMessage: "Tareas solicitadas",
          })}
          icon={<ListAltIcon />}
        />
      </FormBox> */}

      <FormBox>
        <FormBoxTitle
          title={formatMessage({
            id: "ServiceValuationForm.EmployeeProfile",
            defaultMessage: "Perfil del cuidador/a",
          })}
          icon={<AssignmentIndIcon />}
        />
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <FormikRadioGroup
              name="Sexo_trabajador"
              fullWidth
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Sex"
                  defaultMessage="Sexo del trabajador"
                />
              }
              size="small"
              variant="compact"
              margin="nomargin"
              required
              options={[
                {
                  label: formatServiceSex(SERVICE_PREFERRED_SEX.MAN),
                  value: SERVICE_PREFERRED_SEX.MAN,
                },
                {
                  label: formatServiceSex(SERVICE_PREFERRED_SEX.WOMAN),
                  value: SERVICE_PREFERRED_SEX.WOMAN,
                },
                {
                  label: formatServiceSex(SERVICE_PREFERRED_SEX.INDIFFERENT),
                  value: SERVICE_PREFERRED_SEX.INDIFFERENT,
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikSelect
              name="Titulaci_n_oficial"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Titulacion oficial"
                  defaultMessage="Titulación oficial"
                />
              }
              fullWidth
              margin="nomargin"
              size="small"
              variant="compact"
              closeMenuOnSelect
              required
              placeholder={formatMessage({
                id: "Select...",
                defaultMessage: "Selecciona...",
              })}
              labelSuffix={<VisibleForClient />}
              options={officialDegreeOptions}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <FormikTextField
              name="Otras_notas_valoracion"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.OtherRequeriments"
                  defaultMessage="Otros requisitos (se envía al Cliente)"
                />
              }
              fullWidth
              multiline
              maxRows="8"
              minRows="3"
              margin="nomargin"
            />
          </Grid>
        </Grid>
      </FormBox>

      <FormBox>
        <FormBoxTitle
          title={formatMessage({
            id: "ServiceValuationForm.ContractConditions",
            defaultMessage: "Condiciones del contrato",
          })}
          icon={<AssignmentIcon />}
        />
        {disableContractConditions && (
          <StyledAlert severity="warning">
            <FormattedMessage
              id="SelectionForm.No puedes modificar las condiciones del contrato"
              defaultMessage="No puedes modificar las condiciones del contrato"
            />
          </StyledAlert>
        )}
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <FormikTextField
              name="Horario_Servicio"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Schedule"
                  defaultMessage="Horario Servicio"
                />
              }
              fullWidth
              margin="nomargin"
              required
              labelSuffix={<VisibleForClient />}
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikDatePicker
              name="Fecha_objetivo"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.ObjectiveDate"
                  defaultMessage="Fecha objetivo"
                />
              }
              fullWidth
              margin="nomargin"
              size="small"
              required
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormikTextField
              name="Salario_Bruto"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Salary"
                  defaultMessage="Salario"
                />
              }
              moneyformat
              endAdornment={<InputAdornment position="end">€</InputAdornment>}
              fullWidth
              required
              margin="nomargin"
              labelSuffix={<VisibleForClient />}
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormikSelect
              name="Tipo_de_salario"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.SalaryType"
                  defaultMessage="Tipo de salario"
                />
              }
              margin="nomargin"
              size="small"
              variant="compact"
              required
              closeMenuOnSelect={true}
              placeholder={formatMessage({
                id: "Select...",
                defaultMessage: "Selecciona...",
              })}
              options={salaryTypeOptions}
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikDatePicker
              name="Fecha_objetivo_entrevistas"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Fecha cv cliente"
                  defaultMessage="Fecha cv cliente"
                />
              }
              fullWidth
              margin="nomargin"
              size="small"
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikTextField
              name="Horas_jornada_semanal"
              type="number"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.WeeklyHours"
                  defaultMessage="Horas Jornada semanal"
                />
              }
              fullWidth
              required
              margin="nomargin"
              labelSuffix={<VisibleForClient />}
              endAdornment={<InputAdornment position="end">h</InputAdornment>}
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikTextField
              name="Descanso_semanal"
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Descanso semanal"
                  defaultMessage="Descanso semanal"
                />
              }
              fullWidth
              required
              margin="nomargin"
              labelSuffix={<VisibleForClient />}
              disabled={disableContractConditions}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormikTextField
              name="Cl_usulas_especiales"
              multiline
              label={
                <FormattedMessage
                  id="ServiceValuationForm.Clausulas especiales"
                  defaultMessage="Claúsulas especiales"
                />
              }
              minRows="3"
              maxRows="3"
              fullWidth
              margin="nomargin"
              required
              labelSuffix={<VisibleForClient />}
              disabled={disableContractConditions}
            />
          </Grid>
        </Grid>
      </FormBox>
    </Fragment>
  );
};

export default SelectionForm;
